import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import { Paragraph } from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { Button, Hero } from '../../../components';
import useScrollToElement from '../../../hooks/useScrollToElement';

const NodeLandingPage = ({ entity, className }) => {
  const { t } = useTranslation();

  const { scrollRef, scrollToElement } = useScrollToElement({ block: 'start', inline: 'nearest' });

  const classes = classNames(className, 'NodeLandingPage');

  const type = entity.getIn(['type', 0, 'target_id'], '');
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const imageField = entity.getIn(['field_media_item', 0], Immutable.Map());
  const skipToParagraphsEnabled = entity.getIn(['field_enable_skip_to_paragraphs', 0, 'value'], false);

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <Hero
        title={title}
        body={body}
        imageField={imageField}
        type={type}
        button={skipToParagraphsEnabled && (
          <Button iconDown className="mt-4 mt-lg-5" onClick={scrollToElement}>
            {t('buttons.readMore')}
          </Button>
        )}
      />
      <Container className="paragraph-group">
        {entity.get('field_paragraphs') ? (
          <div className="NodeLandingPage__paragraphs" ref={scrollRef}>
            {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
              return (
                <Paragraph
                  key={`paragraph:${id}:${language}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              );
            })}
          </div>
        ) : null}
      </Container>
    </article>
  );
};

export default NodeLandingPage;
